<script lang="ts">
  import type { BoardExternalBusyInterval } from "../../../../../../../../_logic/calendar-types"

  interface Props {
    intervals?: BoardExternalBusyInterval[]
  }

  let { intervals = [] }: Props = $props()
</script>

<div class="external-busy-layer" aria-label="Externe Kalenderbelegungen">
  {#each intervals as interval (interval.calendar_entry_id)}
    <div
      class="external-busy-interval"
      style={`top:${interval.top}px;height:${interval.height}px`}
      data-calendar-entry-id={interval.calendar_entry_id}
      aria-label="Durch einen externen Kalendereintrag belegt"
    >
      <span>Belegt</span>
    </div>
  {/each}
</div>

<style lang="less">
  .external-busy-layer {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
  }

  .external-busy-interval {
    position: absolute;
    left: 0.25rem;
    right: 0.25rem;
    box-sizing: border-box;
    overflow: hidden;
    border: 1px solid color-mix(in srgb, var(--cal-text, #2f4858) 35%, transparent);
    border-left: 3px solid var(--cal-text, #2f4858);
    background:
      repeating-linear-gradient(
        135deg,
        color-mix(in srgb, var(--cal-text, #2f4858) 13%, transparent) 0,
        color-mix(in srgb, var(--cal-text, #2f4858) 13%, transparent) 8px,
        color-mix(in srgb, var(--cal-text, #2f4858) 5%, transparent) 8px,
        color-mix(in srgb, var(--cal-text, #2f4858) 5%, transparent) 16px
      ),
      var(--cal-bg, #fff);

    span {
      display: block;
      padding: 0.2rem 0.35rem;
      color: var(--cal-text, #2f4858);
      font-size: 0.65rem;
      font-weight: 700;
      text-transform: uppercase;
    }
  }
</style>
